import type { DateOnlyString } from 'types/Load';

const DATE_ONLY_RE = /^(\d{4})-(\d{2})-(\d{2})$/;

// Distinguishes date-only values from appointment datetimes in create-load requests.
export interface CreateLoadDateOnlyMetadata {
  isPickupDateOnly: boolean;
  isDropoffDateOnly: boolean;
}

export function isDateOnlyFormValue(value: unknown): value is DateOnlyString {
  if (typeof value !== 'string') return false;
  const match = value.match(DATE_ONLY_RE);
  if (!match) return false;

  const year = Number(match[1]);
  const month = Number(match[2]);
  const day = Number(match[3]);
  const utc = new Date(Date.UTC(year, month - 1, day));
  return (
    utc.getUTCFullYear() === year &&
    utc.getUTCMonth() === month - 1 &&
    utc.getUTCDate() === day
  );
}

export function createLoadDateOnlyMetadata(
  pickupValue: unknown,
  dropoffValue: unknown
): CreateLoadDateOnlyMetadata {
  const metadata: CreateLoadDateOnlyMetadata = {
    isPickupDateOnly: isDateOnlyFormValue(pickupValue),
    isDropoffDateOnly: isDateOnlyFormValue(dropoffValue),
  };
  return metadata;
}
